export const environment = {
  appVersion: '1.0.0-dev',
  production: false,
  API_url: 'http://api.dev.antecipagov.com.br/',
  broad_website: 'http://site.dev.broadfactor.com/',
  antecipa_website: 'http://dev.antecipagov.com.br/',
  GOOGLE_API_KEY: 'AIzaSyDivWztfWG8qtGVlZK-TQlq0lr1pRSo9-w',
};


